import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

export function CheckboxField({
  name,
  onChange,
  label,
  value,
  additionalClass,
  isError,
  disabled,
  indeterminate,
  ...props
}) {
  const ref = useRef(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  return (
    <div
      className={`field field-checkbox ${disabled ? 'field--disabled' : ''} ${
        additionalClass || ''
      } ${isError ? 'is-danger' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="control">
        <input
          type="checkbox"
          name={name}
          onChange={onChange}
          id={name}
          checked={value}
          ref={ref}
          {...props}
        />
        <label htmlFor={name}>{label}</label>
      </div>
    </div>
  )
}

CheckboxField.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.bool,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  isError: PropTypes.bool,
  indeterminate: PropTypes.bool,
}

export default CheckboxField
